// 260817nrai: header error-report capture (html2canvas) + admin list bulk actions

import html2canvasImport from 'html2canvas';

function run_html2canvas(element, options) {
  const capture = typeof html2canvasImport === 'function'
    ? html2canvasImport
    : (html2canvasImport && html2canvasImport.default);
  if (typeof capture !== 'function') {
    return Promise.reject(new Error('html2canvas ist nicht geladen'));
  }
  return capture(element, options);
}

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
}

function showErrorReportToast(message, kind, duration_ms) {
  const toast_kind = kind || 'success';
  const ms = duration_ms || (toast_kind === 'error' ? 12000 : 5000);
  if (window.toast_manager && typeof window.toast_manager.push_many === 'function') {
    window.toast_manager.push_many([{
      kind: toast_kind,
      html: message,
      duration_ms: ms
    }]);
    return;
  }
  const $zone = $('#flash_zone');
  if ($zone.length) {
    $zone.html(`<div class="flash ${toast_kind === 'error' ? 'error' : 'notice'}">${message}</div>`);
  }
}

function errorReportModal() {
  return $('#error_report_modal');
}

function setErrorReportStep(step) {
  const modal = errorReportModal();
  modal.find('[data-error-report-step]').each(function () {
    const match = this.getAttribute('data-error-report-step') === step;
    this.hidden = !match;
  });
}

function resetErrorReportForm() {
  const modal = errorReportModal();
  $('#error_report_description').val('');
  $('#error_report_form_error').text('').attr('hidden', true);
  clearScreenshotPreview();
  modal.removeData('screenshotBlob');
  modal.removeData('forcedMeta');
  setGenogramScreenshotWarning(false);
}

function clearScreenshotPreview() {
  const modal = errorReportModal();
  const objectUrl = modal.data('screenshotObjectUrl');
  if (objectUrl) {
    URL.revokeObjectURL(objectUrl);
  }
  modal.removeData('screenshotObjectUrl');
  const preview = document.getElementById('error_report_screenshot_preview');
  if (preview) {
    preview.removeAttribute('src');
    preview.hidden = true;
  }
  resetScreenshotAnnotation();
  $('#error_report_screenshot_missing').show();
}

function closeErrorReportModal() {
  const modal = errorReportModal();
  resetErrorReportForm();
  if (modal.length) {
    modal.foundation('reveal', 'close');
  }
}

function openErrorReportModal(options) {
  const modal = errorReportModal();
  if (!modal.length) {
    return;
  }
  resetErrorReportForm();
  const opts = options || {};
  if (opts.meta) {
    modal.data('forcedMeta', opts.meta);
  }
  if (opts.skipScreenshot) {
    setErrorReportStep('compose');
  } else {
    setErrorReportStep('explain');
  }
  modal.foundation('reveal', 'open');
}

function waitFrames(count) {
  return new Promise((resolve) => {
    function next(remaining) {
      if (remaining <= 0) {
        resolve();
        return;
      }
      window.requestAnimationFrame(() => next(remaining - 1));
    }
    next(count);
  });
}

function withTimeout(promise, ms, message) {
  return Promise.race([
    promise,
    new Promise((_, reject) => {
      setTimeout(() => reject(new Error(message || 'timeout')), ms);
    })
  ]);
}

function closeRevealForCapture() {
  const modal = errorReportModal();
  return new Promise((resolve) => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      resolve();
    };
    modal.one('closed.fndtn.reveal', finish);
    modal.foundation('reveal', 'close');
    setTimeout(finish, 450);
  });
}

function isActuallyHidden(el) {
  if (!el || el.nodeType !== 1) return false;
  if (el.hidden) return true;
  try {
    const cs = window.getComputedStyle(el);
    return cs.display === 'none' || cs.visibility === 'hidden';
  } catch (error) {
    return false;
  }
}

function ignoreCaptureElement(el) {
  if (!el) return false;
  if (isChartSnapshotElement(el)) return false;
  const id = el.id || '';
  if (id === 'error_report_modal' || id === 'error_report_detail_modal' || id === 'error_report_reply_modal' || id === 'error_report_screenshot_draw' || id === 'error_report_screenshot_zoom' || id === 'dim' || id === 'spinnerbox') return true;
  if (el.classList) {
    if (el.classList.contains('reveal-modal-bg') || el.classList.contains('html2canvas-container')) return true;
    // 260820nrai: closed overlays/menus have no CSS in the clone and stretch the journal form
    if (el.classList.contains('reveal-modal') && !el.classList.contains('open')) return true;
    if ((el.classList.contains('hidden') || el.classList.contains('hide')) && isActuallyHidden(el)) return true;
    if (el.classList.contains('select2-dropdown') || el.classList.contains('select2-container--open')) return true;
    if (el.classList.contains('ui-autocomplete') || el.classList.contains('ui-helper-hidden')) return true;
    if (el.classList.contains('fr-popup') || el.classList.contains('fr-modal')) return true;
    if (el.classList.contains('fr-more-toolbar') && !el.classList.contains('fr-expanded')) return true;
    if (el.classList.contains('fr-sr-only')) return true;
    if (el.classList.contains('period-grid__dropdown')) return true;
    if (el.classList.contains('highcharts-tooltip')) return true;
    // 260826nrai: a11y/exporting leftovers have no CSS in the clone and stretch fieldsets
    if (el.classList.contains('highcharts-a11y-container') ||
        el.classList.contains('highcharts-announcer-container') ||
        el.classList.contains('highcharts-a11y-proxy-container')) return true;
  }
  if (el.hidden) return true;
  // 260817nrai: html2canvas treats :hover as matching, which expands every top-bar dropdown.
  if (el.closest && el.closest('#header ul.dropdown, .top-bar-section ul.dropdown')) return true;
  return false;
}

function isChartSnapshotElement(el) {
  return !!(el && el.classList && el.classList.contains('error-report-chart-snapshot'));
}

function is_security_error(error) {
  const name = (error && error.name) ? error.name : '';
  const msg = (error && error.message) ? error.message : String(error || '');
  return name === 'SecurityError' || /insecure|tainted canvases/i.test(msg);
}

function is_css_parse_error(error) {
  const msg = (error && error.message) ? error.message : String(error || '');
  return /parsing CSS component value/i.test(msg);
}

function is_retryable_screenshot_error(error) {
  return is_security_error(error) || is_css_parse_error(error);
}

function is_cross_origin_src(src) {
  if (!src || src.indexOf('data:') === 0 || src.indexOf('blob:') === 0) return false;
  try {
    return new URL(src, window.location.href).origin !== window.location.origin;
  } catch (e) {
    return true;
  }
}

function media_element_src(el) {
  if (!el || !el.tagName) return '';
  const tag = el.tagName.toLowerCase();
  if (tag === 'img' || tag === 'video' || tag === 'source') {
    return el.currentSrc || el.src || el.getAttribute('src') || '';
  }
  if (tag === 'image') {
    if (el.href && el.href.baseVal) return el.href.baseVal;
    return el.getAttribute('href') || el.getAttribute('xlink:href') || '';
  }
  return '';
}

function is_cross_origin_media(el) {
  if (!el || !el.tagName) return false;
  const tag = el.tagName.toLowerCase();
  if (tag === 'img' || tag === 'video' || tag === 'source' || tag === 'image') {
    return is_cross_origin_src(media_element_src(el));
  }
  return false;
}

function is_media_element(el) {
  if (!el || !el.tagName) return false;
  const tag = el.tagName.toLowerCase();
  return tag === 'img' || tag === 'image' || tag === 'video' || tag === 'canvas' || tag === 'svg';
}

function is_embed_element(el) {
  if (!el || !el.tagName) return false;
  const tag = el.tagName.toLowerCase();
  return tag === 'iframe' || tag === 'frame' || tag === 'object' || tag === 'embed';
}

function origin_of_url(src) {
  try {
    return new URL(src, window.location.href).origin;
  } catch (e) {
    return '(ungültig)';
  }
}

function short_browser() {
  const ua = navigator.userAgent || '';
  const matches = ua.match(/(Firefox|Chrome|CriOS|FxiOS|Edg|Safari)\/[\d.]+/g);
  return matches ? matches.join(' ') : ua.slice(0, 80);
}

function truncate_debug_text(value, max_len) {
  const text = String(value || '');
  const limit = max_len || 90;
  if (text.length <= limit) return text;
  return `${text.slice(0, limit - 1)}…`;
}

function escape_toast_html(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function canvas_taint_message(canvas) {
  try {
    const ctx = canvas.getContext('2d');
    if (!ctx) return 'kein 2d-context';
    ctx.getImageData(0, 0, 1, 1);
    return null;
  } catch (error) {
    return (error && error.message) ? error.message : String(error || 'tainted');
  }
}

function security_error(message) {
  const error = new Error(message || 'The operation is insecure.');
  error.name = 'SecurityError';
  return error;
}

function stylesheet_debug_rows() {
  return Array.from(document.styleSheets || []).map((sheet) => {
    const href = sheet.href || '(inline)';
    let readable = true;
    let read_error = '';
    try {
      void sheet.cssRules;
    } catch (error) {
      readable = false;
      read_error = (error && error.message) ? error.message : String(error || '');
    }
    return { href, readable, read_error, origin: sheet.href ? origin_of_url(sheet.href) : window.location.origin };
  });
}

function collect_screenshot_debug() {
  const image_origins = {};
  const cross_origin_samples = [];
  Array.from(document.images || []).forEach((img) => {
    const src = img.currentSrc || img.src;
    if (!src) return;
    const origin = origin_of_url(src);
    image_origins[origin] = (image_origins[origin] || 0) + 1;
    if (is_cross_origin_src(src) && cross_origin_samples.length < 4) {
      cross_origin_samples.push(truncate_debug_text(src, 80));
    }
  });
  const sheets = stylesheet_debug_rows();
  const font_preloads = Array.from(document.querySelectorAll('link[rel="preload"][as="font"]')).map((link) => ({
    href: truncate_debug_text(link.href, 80),
    crossorigin: link.getAttribute('crossorigin') || ''
  }));
  return {
    page_origin: window.location.origin,
    page_url: truncate_debug_text(window.location.href, 120),
    browser: short_browser(),
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    image_origins,
    cross_origin_samples,
    img_count: document.images.length,
    svg_count: document.querySelectorAll('svg').length,
    canvas_count: document.querySelectorAll('canvas').length,
    iframe_count: document.querySelectorAll('iframe').length,
    unreadable_stylesheets: sheets.filter((row) => !row.readable),
    stylesheet_origins: sheets.reduce((acc, row) => {
      acc[row.origin] = (acc[row.origin] || 0) + 1;
      return acc;
    }, {}),
    font_preloads,
    attempts: []
  };
}

function format_screenshot_error_toast(error) {
  const detail = (error && error.message) ? error.message : String(error || '');
  const debug = (error && error.screenshot_debug) ? error.screenshot_debug : null;
  const lines = [
    escape_toast_html(detail ? `Screenshot konnte nicht erstellt werden (${detail}).` : 'Screenshot konnte nicht erstellt werden.')
  ];
  if (!debug) return lines[0];

  const extra = [];
  if (debug.attempts && debug.attempts.length) {
    extra.push(`Versuche: ${debug.attempts.map((row) => `${row.name} → ${row.message || row.name}`).join('; ')}`);
  }
  extra.push(`Seite: ${debug.page_origin}`);
  extra.push(`Browser: ${debug.browser}`);
  extra.push(`Viewport: ${debug.viewport}`);
  extra.push(`DOM: img ${debug.img_count}, svg ${debug.svg_count}, canvas ${debug.canvas_count}, iframe ${debug.iframe_count}`);
  const origin_text = Object.keys(debug.image_origins || {}).map((origin) => `${origin} (${debug.image_origins[origin]})`).join(', ');
  if (origin_text) extra.push(`Bild-Origins: ${origin_text}`);
  if (debug.cross_origin_samples && debug.cross_origin_samples.length) {
    extra.push(`Fremde Bilder: ${debug.cross_origin_samples.join(' | ')}`);
  }
  const sheet_origin_text = Object.keys(debug.stylesheet_origins || {}).map((origin) => `${origin} (${debug.stylesheet_origins[origin]})`).join(', ');
  if (sheet_origin_text) extra.push(`CSS-Origins: ${sheet_origin_text}`);
  if (debug.unreadable_stylesheets && debug.unreadable_stylesheets.length) {
    extra.push(`CSS unlesbar: ${debug.unreadable_stylesheets.map((row) => truncate_debug_text(row.href, 70)).join(' | ')}`);
  }
  if (debug.font_preloads && debug.font_preloads.length) {
    extra.push(`Font-Preload: ${debug.font_preloads.map((row) => `${row.href}${row.crossorigin ? ` crossorigin=${row.crossorigin}` : ''}`).join(' | ')}`);
  }
  extra.push('html2canvas: useCORS=false, allowTaint=false');
  lines.push(`<div style="margin-top:8px;font-size:12px;line-height:1.35;word-break:break-word">${extra.map((line) => escape_toast_html(line)).join('<br>')}</div>`);
  return lines.join('');
}

function disable_unreadable_stylesheets_in(root_doc) {
  // Intentionally unused in capture: disabling clone <link>s drops app CSS
  // (rounded buttons, colors). Kept for screenshot debug if we need it again.
  const doc = root_doc || document;
  Array.from(doc.styleSheets || []).forEach((sheet) => {
    try {
      void sheet.cssRules;
    } catch (e) {
      const node = sheet.ownerNode;
      if (!node) return;
      node.disabled = true;
      if (node.setAttribute) node.setAttribute('disabled', 'disabled');
    }
  });
}

function clear_clone_canvases(cloned_doc, force) {
  cloned_doc.querySelectorAll('canvas').forEach((canvas) => {
    if (!force && !canvas_taint_message(canvas)) return;
    try {
      const ctx = canvas.getContext('2d');
      if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
    } catch (e) { /* ignore */ }
  });
}

function strip_clone_media(cloned_doc, mode) {
  cloned_doc.querySelectorAll('img, video, source, image').forEach((el) => {
    const src = media_element_src(el);
    const strip = mode === 'no_images' || mode === 'all_external' || is_cross_origin_src(src);
    if (!strip) {
      el.removeAttribute('crossorigin');
      return;
    }
    el.removeAttribute('src');
    el.removeAttribute('srcset');
    el.removeAttribute('href');
    el.removeAttribute('xlink:href');
    el.removeAttribute('crossorigin');
    try { el.src = ''; } catch (e) { /* ignore */ }
  });
  cloned_doc.querySelectorAll('iframe, frame, object, embed').forEach((el) => el.remove());
  clear_clone_canvases(cloned_doc, mode !== 'cross_origin');
  if (mode === 'no_images') {
    cloned_doc.querySelectorAll('svg').forEach((el) => el.remove());
  }
}

function append_clone_image_block_style(cloned_doc, mode) {
  if (mode !== 'all_external' && mode !== 'no_images') return;
  const style = cloned_doc.createElement('style');
  style.textContent = `
    *, *::before, *::after {
      background-image: none !important;
      list-style-image: none !important;
      border-image-source: none !important;
      mask-image: none !important;
      -webkit-mask-image: none !important;
    }
  `;
  (cloned_doc.head || cloned_doc.documentElement).appendChild(style);
}

function sanitize_clone_for_capture(cloned_doc, mode) {
  // 260820nrai: do not disable CORS stylesheets in the clone — html2canvas still
  // uses getComputedStyle, and disabling drops border-radius / button colors.
  strip_clone_media(cloned_doc, mode);
  append_clone_image_block_style(cloned_doc, mode);
}

// 260819nrai: freehand red annotation on the screenshot canvas (fixed size, undo/clear)
const ANNOTATION_COLOR = '#cc0000';
const ANNOTATION_DISPLAY_PX = 3.5;
const screenshotAnnotation = {
  baseImage: null,
  strokes: [],
  currentStroke: null,
  drawing: false
};

function annotationCanvas() {
  return document.getElementById('error_report_screenshot_canvas');
}

function screenshotPreviewToolbar() {
  return document.getElementById('error_report_screenshot_preview_toolbar');
}

function screenshotDrawOverlay() {
  return document.getElementById('error_report_screenshot_draw');
}

function isScreenshotDrawOpen() {
  const overlay = screenshotDrawOverlay();
  return !!(overlay && !overlay.hidden);
}

function annotationLineWidth(canvas) {
  const rect = canvas.getBoundingClientRect();
  const scale = rect.width > 0 ? canvas.width / rect.width : 1;
  return ANNOTATION_DISPLAY_PX * scale;
}

function resetScreenshotAnnotation() {
  closeScreenshotDrawOverlay({ skipPreviewSync: true });
  screenshotAnnotation.baseImage = null;
  screenshotAnnotation.strokes = [];
  screenshotAnnotation.currentStroke = null;
  screenshotAnnotation.drawing = false;
  const canvas = annotationCanvas();
  if (canvas) {
    const ctx = canvas.getContext('2d');
    if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
    canvas.width = 0;
    canvas.height = 0;
  }
  const toolbar = screenshotPreviewToolbar();
  if (toolbar) toolbar.hidden = true;
}

function drawAnnotationStroke(ctx, points, width) {
  if (!points || points.length === 0) return;
  ctx.save();
  ctx.strokeStyle = ANNOTATION_COLOR;
  ctx.fillStyle = ANNOTATION_COLOR;
  ctx.lineWidth = width;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  if (points.length === 1) {
    ctx.beginPath();
    ctx.arc(points[0].x, points[0].y, width / 2, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
    return;
  }
  ctx.beginPath();
  ctx.moveTo(points[0].x, points[0].y);
  for (let i = 1; i < points.length; i += 1) {
    ctx.lineTo(points[i].x, points[i].y);
  }
  ctx.stroke();
  ctx.restore();
}

function redrawScreenshotAnnotation() {
  const canvas = annotationCanvas();
  if (!canvas || !screenshotAnnotation.baseImage) return;
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(screenshotAnnotation.baseImage, 0, 0, canvas.width, canvas.height);
  const width = annotationLineWidth(canvas);
  const strokes = screenshotAnnotation.strokes.slice();
  if (screenshotAnnotation.currentStroke && screenshotAnnotation.currentStroke.length) {
    strokes.push(screenshotAnnotation.currentStroke);
  }
  strokes.forEach((stroke) => drawAnnotationStroke(ctx, stroke, width));
}

function canvasPointFromPointer(canvas, event) {
  const rect = canvas.getBoundingClientRect();
  if (rect.width <= 0 || rect.height <= 0) return { x: 0, y: 0 };
  return {
    x: ((event.clientX - rect.left) / rect.width) * canvas.width,
    y: ((event.clientY - rect.top) / rect.height) * canvas.height
  };
}

function syncScreenshotPreviewFromCanvas() {
  const canvas = annotationCanvas();
  const preview = document.getElementById('error_report_screenshot_preview');
  if (!canvas || !preview || !canvas.width) return;
  try {
    preview.src = canvas.toDataURL('image/jpeg', 0.8);
    preview.hidden = false;
  } catch (e) { /* keep existing preview */ }
}

function openScreenshotDrawOverlay(event) {
  if (event) event.preventDefault();
  if (!screenshotAnnotation.baseImage) return;
  const overlay = screenshotDrawOverlay();
  if (!overlay) return;
  overlay.hidden = false;
  redrawScreenshotAnnotation();
}

function closeScreenshotDrawOverlay(options) {
  const overlay = screenshotDrawOverlay();
  if (!overlay || overlay.hidden) return;
  if (screenshotAnnotation.drawing) endScreenshotAnnotation();
  overlay.hidden = true;
  if (!(options && options.skipPreviewSync)) {
    syncScreenshotPreviewFromCanvas();
  }
}

function loadBlobOntoAnnotationCanvas(blob) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      const canvas = annotationCanvas();
      if (!canvas) {
        resolve();
        return;
      }
      screenshotAnnotation.baseImage = img;
      screenshotAnnotation.strokes = [];
      screenshotAnnotation.currentStroke = null;
      screenshotAnnotation.drawing = false;
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      redrawScreenshotAnnotation();
      syncScreenshotPreviewFromCanvas();
      const toolbar = screenshotPreviewToolbar();
      if (toolbar) toolbar.hidden = false;
      resolve();
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Screenshot-Vorschau fehlgeschlagen'));
    };
    img.src = url;
  });
}

function exportAnnotatedScreenshotBlob() {
  const canvas = annotationCanvas();
  if (!canvas || !canvas.width) {
    return Promise.resolve(errorReportModal().data('screenshotBlob') || null);
  }
  return canvas_to_jpeg_blob(canvas);
}

function startScreenshotAnnotation(event) {
  if (!isScreenshotDrawOpen()) return;
  const canvas = annotationCanvas();
  if (!canvas || !screenshotAnnotation.baseImage) return;
  event.preventDefault();
  screenshotAnnotation.drawing = true;
  screenshotAnnotation.currentStroke = [canvasPointFromPointer(canvas, event)];
  if (canvas.setPointerCapture && event.pointerId != null) {
    try { canvas.setPointerCapture(event.pointerId); } catch (e) { /* ignore */ }
  }
  redrawScreenshotAnnotation();
}

function moveScreenshotAnnotation(event) {
  if (!isScreenshotDrawOpen()) return;
  if (!screenshotAnnotation.drawing || !screenshotAnnotation.currentStroke) return;
  const canvas = annotationCanvas();
  if (!canvas) return;
  event.preventDefault();
  screenshotAnnotation.currentStroke.push(canvasPointFromPointer(canvas, event));
  redrawScreenshotAnnotation();
}

function endScreenshotAnnotation(event) {
  if (!screenshotAnnotation.drawing) return;
  const canvas = annotationCanvas();
  if (canvas && event && event.pointerId != null && canvas.releasePointerCapture) {
    try { canvas.releasePointerCapture(event.pointerId); } catch (e) { /* ignore */ }
  }
  if (screenshotAnnotation.currentStroke && screenshotAnnotation.currentStroke.length) {
    screenshotAnnotation.strokes.push(screenshotAnnotation.currentStroke);
  }
  screenshotAnnotation.currentStroke = null;
  screenshotAnnotation.drawing = false;
  redrawScreenshotAnnotation();
}

function undoScreenshotAnnotation(event) {
  if (event) event.preventDefault();
  if (screenshotAnnotation.drawing) endScreenshotAnnotation();
  screenshotAnnotation.strokes.pop();
  redrawScreenshotAnnotation();
}

function clearScreenshotAnnotation(event) {
  if (event) event.preventDefault();
  screenshotAnnotation.drawing = false;
  screenshotAnnotation.currentStroke = null;
  screenshotAnnotation.strokes = [];
  redrawScreenshotAnnotation();
}

function canvas_to_jpeg_blob(canvas) {
  const taint = canvas_taint_message(canvas);
  if (taint) return Promise.reject(security_error(taint));
  return new Promise((resolve, reject) => {
    try {
      if (typeof canvas.toBlob !== 'function') {
        const data_url = canvas.toDataURL('image/jpeg', 0.8);
        const bytes = atob(data_url.split(',')[1] || '');
        const buffer = new Uint8Array(bytes.length);
        for (let i = 0; i < bytes.length; i += 1) buffer[i] = bytes.charCodeAt(i);
        resolve(new Blob([buffer], { type: 'image/jpeg' }));
        return;
      }
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error('Screenshot leer'));
          return;
        }
        resolve(blob);
      }, 'image/jpeg', 0.8);
    } catch (error) {
      reject(error);
    }
  });
}

function isCaptureCloneDoc(clonedDoc) {
  return !!(clonedDoc && clonedDoc.nodeType === 9 && clonedDoc !== document);
}

function isCaptureCloneEl(clonedDoc, el) {
  return !!(el && isCaptureCloneDoc(clonedDoc) && el.ownerDocument === clonedDoc);
}

function html2canvas_capture_options(ignore_fn, sanitize_mode, chart_snapshots, froala_icon_snapshots) {
  const viewport_width = window.innerWidth;
  const viewport_height = window.innerHeight;
  return {
    // 260820nrai: viewport-sized clone; full-page iframe made Highcharts cover the journal
    x: window.scrollX,
    y: window.scrollY,
    width: viewport_width,
    height: viewport_height,
    windowWidth: viewport_width,
    windowHeight: viewport_height,
    scrollX: 0,
    scrollY: 0,
    scale: 1,
    // CORS-reload from HTTP cache taints the canvas on hosts with a separate asset URL.
    useCORS: false,
    allowTaint: false,
    foreignObjectRendering: false,
    logging: false,
    imageTimeout: 8000,
    backgroundColor: '#ffffff',
    ignoreElements: ignore_fn,
    onclone: function (cloned_doc) {
      if (!isCaptureCloneDoc(cloned_doc)) return;
      pinStickyHeaderInCaptureClone(cloned_doc);
      flattenCaptureChromeInClone(cloned_doc);
      collapseHeaderMenusInClone(cloned_doc);
      sanitize_clone_for_capture(cloned_doc, sanitize_mode);
      restyleNativeControlsInClone(cloned_doc);
      copyLiveButtonLooksToClone(cloned_doc);
      hideCollapsedLiveUiInClone(cloned_doc);
      lockLiveLayoutBoxesInClone(cloned_doc);
      clipChartsInClone(cloned_doc);
      applyChartSnapshotsToClone(cloned_doc, chart_snapshots);
      applyFroalaIconSnapshotsToClone(cloned_doc, froala_icon_snapshots);
      patchHtml2canvasCssParseHolesInClone(cloned_doc);
    }
  };
}

function restoreHeaderMenuInlineStyles() {
  document.querySelectorAll('#header ul.dropdown, .top-bar-section ul.dropdown').forEach((el) => {
    el.style.removeProperty('display');
    el.style.removeProperty('visibility');
    el.style.removeProperty('opacity');
  });
}

// 260819nrai: html2canvas skips repeating-linear-gradient and paints grey box-shadow as a fill
function expandRepeatingLinearGradient(value, coverPx) {
  const match = String(value || '').match(/repeating-linear-gradient\((.*)\)/i);
  if (!match) return null;
  const inner = match[1];
  const pxValues = Array.from(inner.matchAll(/(-?\d+(?:\.\d+)?)px/g)).map((row) => parseFloat(row[1]));
  const period = pxValues.length ? Math.max.apply(null, pxValues) : 0;
  if (!(period > 0)) return `linear-gradient(${inner})`;
  const firstComma = inner.indexOf(',');
  if (firstComma < 0) return `linear-gradient(${inner})`;
  const angle = inner.slice(0, firstComma).trim();
  const stopRe = /(rgba?\([^)]+\)|hsla?\([^)]+\)|#[0-9a-fA-F]{3,8}|[a-zA-Z]+)\s+(-?\d+(?:\.\d+)?)px/g;
  const stops = [];
  let stopMatch = stopRe.exec(inner);
  while (stopMatch) {
    stops.push({ color: stopMatch[1], px: parseFloat(stopMatch[2]) });
    stopMatch = stopRe.exec(inner);
  }
  if (!stops.length) return `linear-gradient(${inner})`;
  const span = Math.max(coverPx || 0, window.innerWidth, 1200) * 1.5;
  const repeats = Math.max(8, Math.ceil(span / period));
  const parts = [angle];
  for (let i = 0; i < repeats; i += 1) {
    const base = i * period;
    stops.forEach((stop) => {
      parts.push(`${stop.color} ${base + stop.px}px`);
    });
  }
  return `linear-gradient(${parts.join(', ')})`;
}

function copyOpaqueBackgroundForCapture(clonedEl, liveEl) {
  const liveStyle = window.getComputedStyle(liveEl);
  const color = liveStyle.backgroundColor;
  if (color && color !== 'transparent' && color !== 'rgba(0, 0, 0, 0)' && isHtml2canvasSafeCssValue(color)) {
    clonedEl.style.setProperty('background-color', color, 'important');
  }
  const image = String(liveStyle.backgroundImage || '');
  if (/repeating-linear-gradient/i.test(image)) {
    const expanded = expandRepeatingLinearGradient(image, liveEl.getBoundingClientRect().width);
    if (expanded && isHtml2canvasSafeCssValue(expanded)) {
      clonedEl.style.setProperty('background-image', expanded, 'important');
      clonedEl.style.setProperty('background-repeat', 'repeat', 'important');
    }
  }
}

function flattenCaptureChromeInClone(clonedDoc) {
  if (!isCaptureCloneDoc(clonedDoc)) return;
  ['header', 'footer'].forEach((id) => {
    const liveEl = document.getElementById(id);
    const clonedEl = clonedDoc.getElementById(id);
    if (!liveEl || !isCaptureCloneEl(clonedDoc, clonedEl)) return;
    copyOpaqueBackgroundForCapture(clonedEl, liveEl);
    clonedEl.style.setProperty('box-shadow', 'none', 'important');
    clonedEl.style.setProperty('-webkit-box-shadow', 'none', 'important');
    const textColor = window.getComputedStyle(liveEl).color;
    if (textColor && isHtml2canvasSafeCssValue(textColor)) clonedEl.style.setProperty('color', textColor, 'important');
    if (id === 'header') {
      clonedEl.querySelectorAll('.top-bar').forEach((child) => {
        copyOpaqueBackgroundForCapture(child, liveEl);
        child.style.setProperty('box-shadow', 'none', 'important');
      });
    }
  });
}

// 260820nrai: html2canvas paints <input type=submit> / <button> as grey OS controls
const NATIVE_CAPTURE_CONTROL_SELECTOR = 'button, input[type="submit"], input[type="button"], input[type="reset"]';
const BUTTON_CAPTURE_SELECTOR = `${NATIVE_CAPTURE_CONTROL_SELECTOR}, a.button, .button`;

function stampCaptureControls() {
  const stamped = [];
  document.querySelectorAll(BUTTON_CAPTURE_SELECTOR).forEach((el) => {
    if (ignoreCaptureElement(el) || el.getAttribute('data-er-cap')) return;
    el.setAttribute('data-er-cap', String(stamped.length + 1));
    stamped.push(el);
  });
  return stamped;
}

function unstampCaptureControls(stamped) {
  (stamped || []).forEach((el) => {
    if (el && el.removeAttribute) el.removeAttribute('data-er-cap');
  });
}

// 260820nrai: GAS/FK chips use height:100%; pin them via stamps because they have no ids
const PERCENT_HEIGHT_BOX_SELECTOR = [
  '.cds',
  '.cds_gascales_expired',
  '.cds_ziele_expired',
  '.cscs',
  '.cscs_container',
  '.fk_warning',
  '.fk_warning_flex',
  '.crucial_date_warning',
  '#element_docus_gascales_warning',
  '#element_fehlkontakte_warning'
].join(', ');

function stampPercentHeightBoxes() {
  const stamped = [];
  document.querySelectorAll(PERCENT_HEIGHT_BOX_SELECTOR).forEach((el) => {
    if (el.getAttribute('data-er-box')) return;
    el.setAttribute('data-er-box', String(stamped.length + 1));
    stamped.push(el);
  });
  return stamped;
}

function unstampPercentHeightBoxes(stamped) {
  (stamped || []).forEach((el) => {
    if (el && el.removeAttribute) el.removeAttribute('data-er-box');
  });
}

function stampHtml2canvasIgnore(selector) {
  const stamped = [];
  document.querySelectorAll(selector).forEach((el) => {
    if (el.hasAttribute('data-html2canvas-ignore')) return;
    el.setAttribute('data-html2canvas-ignore', 'true');
    stamped.push(el);
  });
  return stamped;
}

function unstampHtml2canvasIgnore(stamped) {
  (stamped || []).forEach((el) => {
    if (el && el.removeAttribute) el.removeAttribute('data-html2canvas-ignore');
  });
}

function nativeControlLabel(el) {
  if (!el) return '';
  const tag = (el.tagName || '').toLowerCase();
  if (tag === 'input') return el.value || el.getAttribute('value') || '';
  return String(el.innerText || el.textContent || '').replace(/\s+/g, ' ').trim();
}

function liveMatchForCloneEl(cloneEl) {
  if (cloneEl && cloneEl.id) {
    const byId = document.getElementById(cloneEl.id);
    if (byId) return byId;
  }
  const capStamp = cloneEl && cloneEl.getAttribute('data-er-cap');
  if (capStamp) return document.querySelector(`[data-er-cap="${capStamp}"]`);
  const boxStamp = cloneEl && cloneEl.getAttribute('data-er-box');
  if (boxStamp) return document.querySelector(`[data-er-box="${boxStamp}"]`);
  return null;
}

function isHtml2canvasSafeCssValue(value) {
  const text = String(value || '').trim();
  if (!text) return false;
  // 260820nrai: html2canvas 1.4 throws "unexpected EOF" on empty or modern color functions
  if (/color-mix\(|oklch\(|oklab\(|(?:^|[\s,])(?:lab|lch)\(|light-dark\(|color\(|if\(|anchor\(/i.test(text)) {
    return false;
  }
  return true;
}

// html2canvas 1.4 parse() uses "".toString() instead of the property's initial value.
const HTML2CANVAS_CSS_FALLBACKS = {
  animationDuration: '0s',
  backgroundClip: 'border-box',
  backgroundColor: 'rgba(0, 0, 0, 0)',
  backgroundImage: 'none',
  backgroundOrigin: 'padding-box',
  backgroundPosition: '0% 0%',
  backgroundRepeat: 'repeat',
  backgroundSize: 'auto',
  borderTopColor: 'rgb(0, 0, 0)',
  borderRightColor: 'rgb(0, 0, 0)',
  borderBottomColor: 'rgb(0, 0, 0)',
  borderLeftColor: 'rgb(0, 0, 0)',
  borderTopLeftRadius: '0px',
  borderTopRightRadius: '0px',
  borderBottomRightRadius: '0px',
  borderBottomLeftRadius: '0px',
  borderTopStyle: 'none',
  borderRightStyle: 'none',
  borderBottomStyle: 'none',
  borderLeftStyle: 'none',
  borderTopWidth: '0px',
  borderRightWidth: '0px',
  borderBottomWidth: '0px',
  borderLeftWidth: '0px',
  boxShadow: 'none',
  color: 'rgb(0, 0, 0)',
  content: 'none',
  counterIncrement: 'none',
  counterReset: 'none',
  cssFloat: 'none',
  direction: 'ltr',
  display: 'block',
  float: 'none',
  fontFamily: 'sans-serif',
  fontSize: '16px',
  fontStyle: 'normal',
  fontVariant: 'normal',
  fontWeight: '400',
  letterSpacing: 'normal',
  lineBreak: 'auto',
  lineHeight: 'normal',
  listStyleImage: 'none',
  listStylePosition: 'outside',
  listStyleType: 'disc',
  marginTop: '0px',
  marginRight: '0px',
  marginBottom: '0px',
  marginLeft: '0px',
  opacity: '1',
  overflow: 'visible',
  overflowWrap: 'normal',
  paddingTop: '0px',
  paddingRight: '0px',
  paddingBottom: '0px',
  paddingLeft: '0px',
  paintOrder: 'normal',
  position: 'static',
  quotes: 'none',
  textAlign: 'start',
  textDecoration: 'none',
  textDecorationColor: 'rgb(0, 0, 0)',
  textDecorationLine: 'none',
  textShadow: 'none',
  textTransform: 'none',
  transform: 'none',
  transformOrigin: '50% 50% 0px',
  visibility: 'visible',
  webkitTextStrokeColor: 'rgb(0, 0, 0)',
  webkitTextStrokeWidth: '0px',
  wordBreak: 'normal',
  zIndex: 'auto'
};

function kebabToCamelCss(name) {
  return String(name || '').replace(/-([a-z])/g, (_, chr) => chr.toUpperCase());
}

function svgPresentationAttr(elt, prop) {
  if (!elt || !elt.getAttribute) return '';
  const kebab = String(prop || '').replace(/[A-Z]/g, (chr) => `-${chr.toLowerCase()}`);
  return elt.getAttribute(kebab) || elt.getAttribute(prop) || '';
}

function sanitizeHtml2canvasCssValue(prop, value, elt) {
  const text = String(value || '').trim();
  if (!text) {
    const fromAttr = svgPresentationAttr(elt, prop);
    if (fromAttr) return fromAttr;
    // Only fill properties html2canvas parses; "none" on empty SVG attrs broke Froala icons
    return Object.prototype.hasOwnProperty.call(HTML2CANVAS_CSS_FALLBACKS, prop)
      ? HTML2CANVAS_CSS_FALLBACKS[prop]
      : '';
  }
  if (/color-mix\(|oklch\(|oklab\(|(?:^|[\s,])(?:lab|lch)\(|light-dark\(|color\(|if\(|anchor\(/i.test(text)) {
    if (/gradient|url\(/i.test(text)) return HTML2CANVAS_CSS_FALLBACKS.backgroundImage;
    if (/image|shadow/i.test(prop)) return 'none';
    return HTML2CANVAS_CSS_FALLBACKS[prop] || 'rgb(0, 0, 0)';
  }
  return text;
}

function wrapComputedStyleForHtml2canvas(style, elt) {
  if (!style) return style;
  return new Proxy(style, {
    get(target, prop) {
      if (prop === 'getPropertyValue') {
        return (name) => {
          let raw = '';
          try { raw = target.getPropertyValue(name); } catch (error) { raw = ''; }
          return sanitizeHtml2canvasCssValue(kebabToCamelCss(name), raw, elt);
        };
      }
      if (typeof prop === 'symbol') return target[prop];
      const val = target[prop];
      if (typeof val === 'function') return val.bind(target);
      if (typeof val === 'string') return sanitizeHtml2canvasCssValue(prop, val, elt);
      return val;
    }
  });
}

function installHtml2canvasComputedStyleGuard(view) {
  const win = view || window;
  const original = win.getComputedStyle;
  if (!original || original.__erH2cWrapped) {
    return function restoreHtml2canvasComputedStyle() {};
  }
  const wrapped = function getComputedStyleForHtml2canvas(elt, pseudoElt) {
    return wrapComputedStyleForHtml2canvas(original.call(win, elt, pseudoElt), elt);
  };
  wrapped.__erH2cWrapped = true;
  win.getComputedStyle = wrapped;
  return function restoreHtml2canvasComputedStyle() {
    if (win.getComputedStyle === wrapped) win.getComputedStyle = original;
  };
}

function patchHtml2canvasCssParseHolesInClone(clonedDoc) {
  if (!isCaptureCloneDoc(clonedDoc)) return;
  installHtml2canvasComputedStyleGuard(clonedDoc.defaultView);
}

function copyVisualStylesFromLive(liveEl, cloneEl) {
  const cs = window.getComputedStyle(liveEl);
  const rect = liveEl.getBoundingClientRect();
  [
    'box-sizing', 'display', 'vertical-align', 'text-align',
    'font-family', 'font-size', 'font-weight', 'font-style', 'line-height',
    'color', 'background-color',
    'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width',
    'border-top-style', 'border-right-style', 'border-bottom-style', 'border-left-style',
    'border-top-color', 'border-right-color', 'border-bottom-color', 'border-left-color',
    'border-top-left-radius', 'border-top-right-radius', 'border-bottom-right-radius', 'border-bottom-left-radius',
    'padding-top', 'padding-right', 'padding-bottom', 'padding-left',
    'margin-top', 'margin-right', 'margin-bottom', 'margin-left',
    'white-space', 'overflow', 'opacity'
  ].forEach((prop) => {
    const value = cs.getPropertyValue(prop);
    if (!isHtml2canvasSafeCssValue(value)) return;
    cloneEl.style.setProperty(prop, value, 'important');
  });
  const deco = cs.getPropertyValue('text-decoration-line') || 'none';
  if (isHtml2canvasSafeCssValue(deco)) cloneEl.style.setProperty('text-decoration-line', deco, 'important');
  cloneEl.style.setProperty('background-image', 'none', 'important');
  cloneEl.style.setProperty('width', `${Math.round(rect.width)}px`, 'important');
  cloneEl.style.setProperty('height', `${Math.round(rect.height)}px`, 'important');
  cloneEl.style.setProperty('box-shadow', 'none', 'important');
  cloneEl.style.setProperty('-webkit-box-shadow', 'none', 'important');
  cloneEl.style.setProperty('appearance', 'none', 'important');
  cloneEl.style.setProperty('-webkit-appearance', 'none', 'important');
}

function isFroalaToolbarControl(el) {
  if (!el || !el.closest) return false;
  if (el.classList && (el.classList.contains('fr-command') || el.classList.contains('fr-btn'))) return true;
  return !!el.closest('.fr-toolbar, .fr-popup, .fr-modal, .fr-second-toolbar');
}

function restyleNativeControlsInClone(clonedDoc) {
  if (!isCaptureCloneDoc(clonedDoc)) return;
  clonedDoc.querySelectorAll(NATIVE_CAPTURE_CONTROL_SELECTOR).forEach((cloneEl) => {
    if (!isCaptureCloneEl(clonedDoc, cloneEl)) return;
    if (isFroalaToolbarControl(cloneEl)) return;
    const liveEl = liveMatchForCloneEl(cloneEl);
    if (!liveEl || !cloneEl.parentNode) return;
    if (isFroalaToolbarControl(liveEl)) return;
    const fake = clonedDoc.createElement('div');
    fake.className = cloneEl.className || '';
    fake.setAttribute('data-er-fake-control', '1');
    copyVisualStylesFromLive(liveEl, fake);
    fake.style.setProperty('display', 'inline-block', 'important');
    fake.textContent = nativeControlLabel(liveEl);
    cloneEl.parentNode.replaceChild(fake, cloneEl);
  });
}

function copyLiveButtonLooksToClone(clonedDoc) {
  if (!isCaptureCloneDoc(clonedDoc)) return;
  clonedDoc.querySelectorAll(BUTTON_CAPTURE_SELECTOR).forEach((cloneEl) => {
    if (!isCaptureCloneEl(clonedDoc, cloneEl)) return;
    if (cloneEl.getAttribute('data-er-fake-control')) return;
    const liveEl = liveMatchForCloneEl(cloneEl);
    if (!liveEl) return;
    copyVisualStylesFromLive(liveEl, cloneEl);
  });
}

function hideCloneEl(cloneEl) {
  cloneEl.style.setProperty('display', 'none', 'important');
  cloneEl.style.setProperty('height', '0', 'important');
  cloneEl.style.setProperty('max-height', '0', 'important');
  cloneEl.style.setProperty('min-height', '0', 'important');
  cloneEl.style.setProperty('overflow', 'hidden', 'important');
}

function hideCollapsedLiveUiInClone(clonedDoc) {
  if (!isCaptureCloneDoc(clonedDoc)) return;
  clonedDoc.querySelectorAll('.reveal-modal:not(.open), .period-grid__dropdown, .fr-more-toolbar:not(.fr-expanded), .fr-popup, .fr-modal, .fr-sr-only, .highcharts-a11y-container, .highcharts-announcer-container, .highcharts-a11y-proxy-container').forEach((cloneEl) => {
    if (!isCaptureCloneEl(clonedDoc, cloneEl)) return;
    hideCloneEl(cloneEl);
  });
  // 260820nrai: km/Telefonate keep class "hidden" after jQuery .show(); only hide if live is actually gone
  clonedDoc.querySelectorAll('.hidden, .hide, [hidden]').forEach((cloneEl) => {
    if (!isCaptureCloneEl(clonedDoc, cloneEl)) return;
    const liveEl = liveMatchForCloneEl(cloneEl);
    if (liveEl && !isActuallyHidden(liveEl)) {
      const liveDisplay = window.getComputedStyle(liveEl).display;
      if (liveDisplay && liveDisplay !== 'none') {
        cloneEl.style.setProperty('display', liveDisplay, 'important');
      }
      cloneEl.classList.remove('hidden', 'hide');
      cloneEl.removeAttribute('hidden');
      return;
    }
    hideCloneEl(cloneEl);
  });
  clonedDoc.querySelectorAll('[id]').forEach((cloneEl) => {
    if (!cloneEl.id || !isCaptureCloneEl(clonedDoc, cloneEl)) return;
    const liveEl = document.getElementById(cloneEl.id);
    if (!liveEl) return;
    if (isActuallyHidden(liveEl)) hideCloneEl(cloneEl);
  });
}

function lockSelectorBoxesToLive(clonedDoc, selector) {
  const liveList = document.querySelectorAll(selector);
  clonedDoc.querySelectorAll(selector).forEach((cloneEl, index) => {
    if (!isCaptureCloneEl(clonedDoc, cloneEl)) return;
    const liveEl = liveMatchForCloneEl(cloneEl) || liveList[index] || null;
    if (!liveEl) return;
    if (isActuallyHidden(liveEl)) {
      hideCloneEl(cloneEl);
      return;
    }
    const rect = liveEl.getBoundingClientRect();
    const height = Math.round(rect.height || liveEl.offsetHeight || 0);
    const width = Math.round(rect.width || liveEl.offsetWidth || 0);
    if (height < 1 && width < 1) {
      hideCloneEl(cloneEl);
      return;
    }
    if (height > 0) {
      cloneEl.style.setProperty('height', `${height}px`, 'important');
      cloneEl.style.setProperty('max-height', `${height}px`, 'important');
      cloneEl.style.setProperty('min-height', '0', 'important');
      cloneEl.style.setProperty('overflow', 'hidden', 'important');
    }
    if (width > 0) {
      cloneEl.style.setProperty('width', `${width}px`, 'important');
      cloneEl.style.setProperty('max-width', `${width}px`, 'important');
    }
  });
}

function lockLiveLayoutBoxesInClone(clonedDoc) {
  if (!isCaptureCloneDoc(clonedDoc)) return;
  // 260820nrai: clone fieldset/froala/form stretch to the iframe height; pin to live boxes
  [
    'the_form',
    'time_records_form',
    'fieldset_bearbeiten',
    'journal_options',
    'form_element_kurzdoku',
    'form_element_geheimnisdoku',
    'time_records_journal',
    'balance_chart'
  ].forEach((id) => {
    const liveEl = document.getElementById(id);
    const cloneEl = clonedDoc.getElementById(id);
    if (!liveEl || !isCaptureCloneEl(clonedDoc, cloneEl)) return;
    const height = liveEl.offsetHeight;
    const width = liveEl.offsetWidth;
    if (height > 0) {
      cloneEl.style.setProperty('height', `${height}px`, 'important');
      cloneEl.style.setProperty('max-height', `${height}px`, 'important');
      cloneEl.style.setProperty('overflow', 'hidden', 'important');
    }
    if (width > 0) {
      cloneEl.style.setProperty('width', `${width}px`, 'important');
      cloneEl.style.setProperty('max-width', `${width}px`, 'important');
    }
  });
  lockSelectorBoxesToLive(clonedDoc, '.fr-box, .fr-wrapper, .fr-element');
  lockSelectorBoxesToLive(clonedDoc, PERCENT_HEIGHT_BOX_SELECTOR);
  // 260826nrai: any fieldset (not only journal #fieldset_bearbeiten) grows to the clone iframe height
  lockSelectorBoxesToLive(clonedDoc, 'fieldset');
  clonedDoc.querySelectorAll('select').forEach((cloneEl) => {
    if (!isCaptureCloneEl(clonedDoc, cloneEl)) return;
    const liveEl = liveMatchForCloneEl(cloneEl);
    if (liveEl && window.getComputedStyle(liveEl).display === 'none') {
      cloneEl.style.setProperty('display', 'none', 'important');
    }
    if (!liveEl || window.getComputedStyle(liveEl).display === 'none' || liveEl.classList.contains('select2-hidden-accessible')) {
      cloneEl.size = 1;
      cloneEl.removeAttribute('multiple');
    }
  });
}

function clipChartsInClone(clonedDoc) {
  if (!isCaptureCloneDoc(clonedDoc)) return;
  document.querySelectorAll('#balance_chart, [data-highcharts-chart], .highcharts-container').forEach((liveEl) => {
    const rect = liveEl.getBoundingClientRect();
    if (rect.width < 1 || rect.height < 1) return;
    const clonedEl = clonedCounterpart(clonedDoc, liveEl);
    if (!isCaptureCloneEl(clonedDoc, clonedEl)) return;
    const width = Math.round(rect.width);
    const height = Math.round(rect.height);
    lockCaptureBoxSize(clonedEl, width, height);
    lockHighchartsHostInClone(clonedDoc, liveEl, clonedEl, width, height);
    clonedEl.querySelectorAll('svg').forEach((svg) => {
      if (svg.ownerDocument !== clonedDoc) return;
      svg.remove();
    });
  });
}

// 260826nrai: Highcharts puts data-highcharts-chart on .highcharts-container (height:100%).
// Pin the renderTo host as well, otherwise the clone iframe stretches the wrapping fieldset.
function highchartsHostElement(liveEl) {
  if (!liveEl) return null;
  if (liveEl.classList.contains('highcharts-container')) return liveEl.parentElement;
  const closest = liveEl.closest('#balance_chart, [data-highcharts-chart]');
  if (closest && closest !== liveEl && !closest.classList.contains('highcharts-container')) return closest;
  return liveEl.parentElement;
}

function lockHighchartsHostInClone(clonedDoc, liveEl, clonedEl, width, height) {
  const liveParent = highchartsHostElement(liveEl);
  if (!liveParent || liveParent === document.body) return;
  let clonedParent = liveParent.id ? clonedDoc.getElementById(liveParent.id) : null;
  if (!isCaptureCloneEl(clonedDoc, clonedParent) && clonedEl && clonedEl.parentElement) {
    clonedParent = clonedEl.parentElement;
  }
  if (!isCaptureCloneEl(clonedDoc, clonedParent) || clonedParent === clonedEl) return;
  lockCaptureBoxSize(clonedParent, width, height);
}

function liveChartCaptureBoxes() {
  const containers = Array.from(document.querySelectorAll('.highcharts-container'));
  if (containers.length) return containers;
  return Array.from(document.querySelectorAll('#balance_chart, [data-highcharts-chart]')).filter((el) => (
    el.querySelector('svg, canvas')
  ));
}

function clonedCounterpart(clonedDoc, liveEl) {
  if (!isCaptureCloneDoc(clonedDoc) || !liveEl) return null;
  if (liveEl.id) {
    const byId = clonedDoc.getElementById(liveEl.id);
    if (isCaptureCloneEl(clonedDoc, byId)) return byId;
  }
  const liveList = document.querySelectorAll('.highcharts-container');
  const idx = Array.prototype.indexOf.call(liveList, liveEl);
  if (idx < 0) return null;
  const cloneEl = clonedDoc.querySelectorAll('.highcharts-container')[idx] || null;
  return isCaptureCloneEl(clonedDoc, cloneEl) ? cloneEl : null;
}

function lockCaptureBoxSize(el, width, height) {
  const w = `${width}px`;
  const h = `${height}px`;
  el.style.setProperty('width', w, 'important');
  el.style.setProperty('height', h, 'important');
  el.style.setProperty('max-width', w, 'important');
  el.style.setProperty('max-height', h, 'important');
  el.style.setProperty('overflow', 'hidden', 'important');
  el.style.setProperty('position', 'relative', 'important');
}

function highchartsSvgString(liveEl) {
  const charts = (window.Highcharts && window.Highcharts.charts) || [];
  for (let i = 0; i < charts.length; i += 1) {
    const chart = charts[i];
    if (!chart || !chart.container) continue;
    if (chart.container !== liveEl && !liveEl.contains(chart.container) && !chart.container.contains(liveEl)) continue;
    if (typeof chart.getSVG !== 'function') return null;
    try {
      return chart.getSVG({ chart: { width: chart.chartWidth, height: chart.chartHeight } });
    } catch (error) {
      return null;
    }
  }
  return null;
}

function rasterizeSvgMarkupToPng(xml, width, height, options) {
  const opts = options || {};
  return new Promise((resolve) => {
    if (!xml || !(width > 0) || !(height > 0)) {
      resolve(null);
      return;
    }
    let settled = false;
    let objectUrl = '';
    const finish = (value) => {
      if (settled) return;
      settled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      resolve(value);
    };
    const timer = setTimeout(() => finish(null), 2500);
    try {
      const img = new Image();
      img.onload = function () {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          if (opts.background !== false) {
            ctx.fillStyle = opts.background || '#ffffff';
            ctx.fillRect(0, 0, width, height);
          }
          ctx.drawImage(img, 0, 0, width, height);
          clearTimeout(timer);
          finish(canvas.toDataURL('image/png'));
        } catch (error) {
          clearTimeout(timer);
          finish(null);
        }
      };
      img.onerror = function () {
        clearTimeout(timer);
        finish(null);
      };
      // 260820nrai: blob URL avoids data-URI length limits on Highcharts SVG
      const blob = new Blob([xml], { type: 'image/svg+xml;charset=utf-8' });
      objectUrl = URL.createObjectURL(blob);
      img.src = objectUrl;
    } catch (error) {
      clearTimeout(timer);
      finish(null);
    }
  });
}

function rasterizeSvgToPng(svgEl, width, height) {
  if (!svgEl) return Promise.resolve(null);
  try {
    const copy = svgEl.cloneNode(true);
    copy.setAttribute('width', String(width));
    copy.setAttribute('height', String(height));
    copy.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    if (!copy.getAttribute('viewBox') && svgEl.viewBox && svgEl.viewBox.baseVal && svgEl.viewBox.baseVal.width) {
      const vb = svgEl.viewBox.baseVal;
      copy.setAttribute('viewBox', `${vb.x} ${vb.y} ${vb.width} ${vb.height}`);
    }
    return rasterizeSvgMarkupToPng(new XMLSerializer().serializeToString(copy), width, height);
  } catch (error) {
    return Promise.resolve(null);
  }
}

function snapshotLiveChartSizes() {
  const charts = (window.Highcharts && window.Highcharts.charts) || [];
  return charts.filter(Boolean).map((chart) => ({
    chart,
    width: chart.chartWidth,
    height: chart.chartHeight
  }));
}

function restoreLiveChartSizes(snapshots) {
  (snapshots || []).forEach((row) => {
    if (!row || !row.chart) return;
    try {
      if (typeof row.chart.setSize === 'function' && row.width > 0 && row.height > 0) {
        row.chart.setSize(row.width, row.height, false);
      } else if (typeof row.chart.reflow === 'function') {
        row.chart.reflow();
      }
    } catch (error) { /* live chart restore is best-effort */ }
  });
}

async function collectLiveChartSnapshots() {
  const boxes = liveChartCaptureBoxes();
  const snapshots = [];
  for (let i = 0; i < boxes.length; i += 1) {
    const liveEl = boxes[i];
    const rect = liveEl.getBoundingClientRect();
    if (rect.width < 1 || rect.height < 1) continue;
    const width = Math.max(1, Math.round(rect.width));
    const height = Math.max(1, Math.round(rect.height));
    const parent = highchartsHostElement(liveEl);
    const svgMarkup = highchartsSvgString(liveEl);
    const png = canvasToPngDataUrl(liveEl.querySelector('canvas'))
      || (svgMarkup ? await rasterizeSvgMarkupToPng(svgMarkup, width, height) : null)
      || await rasterizeSvgToPng(liveEl.querySelector('svg'), width, height);
    snapshots.push({
      id: liveEl.id || '',
      index: i,
      parentId: parent && parent.id !== liveEl.id ? parent.id : '',
      width,
      height,
      png
    });
  }
  return snapshots;
}

function applyChartSnapshotsToClone(clonedDoc, snapshots) {
  if (!isCaptureCloneDoc(clonedDoc) || !snapshots || !snapshots.length) return;
  const cloneBoxes = clonedDoc.querySelectorAll('.highcharts-container');
  snapshots.forEach((snap, index) => {
    let clonedEl = snap.id ? clonedDoc.getElementById(snap.id) : null;
    if (!isCaptureCloneEl(clonedDoc, clonedEl)) clonedEl = cloneBoxes[snap.index] || cloneBoxes[index] || null;
    if (!isCaptureCloneEl(clonedDoc, clonedEl)) return;
    lockCaptureBoxSize(clonedEl, snap.width, snap.height);
    if (snap.parentId) {
      const clonedParent = clonedDoc.getElementById(snap.parentId);
      if (isCaptureCloneEl(clonedDoc, clonedParent)) lockCaptureBoxSize(clonedParent, snap.width, snap.height);
    } else if (clonedEl.parentElement) {
      lockCaptureBoxSize(clonedEl.parentElement, snap.width, snap.height);
    }
    if (snap.png) {
      replaceCloneWithChartSnapshot(clonedDoc, clonedEl, snap.png, snap.width, snap.height);
    } else {
      clonedEl.innerHTML = '';
    }
  });
}

function canvasToPngDataUrl(canvas) {
  if (!canvas) return null;
  try {
    return canvas.toDataURL('image/png');
  } catch (error) {
    return null;
  }
}

function froalaToolbarIconSvgs() {
  return Array.from(document.querySelectorAll('.fr-toolbar svg.fr-svg'));
}

function rasterizeFroalaIcon(svgEl, width, height) {
  if (!svgEl) return Promise.resolve(null);
  try {
    const copy = svgEl.cloneNode(true);
    copy.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    copy.setAttribute('width', String(width));
    copy.setAttribute('height', String(height));
    if (!copy.getAttribute('viewBox')) copy.setAttribute('viewBox', '0 0 24 24');
    let color = '#333333';
    try { color = window.getComputedStyle(svgEl).color || color; } catch (error) { /* keep default */ }
    copy.querySelectorAll('path').forEach((path, index) => {
      const livePath = svgEl.querySelectorAll('path')[index];
      let fill = color;
      try {
        if (livePath) fill = window.getComputedStyle(livePath).fill || color;
      } catch (error) { /* keep default */ }
      if (!fill || fill === 'none' || fill === 'rgba(0, 0, 0, 0)') fill = color;
      path.setAttribute('fill', fill);
      path.style.fill = fill;
    });
    return rasterizeSvgMarkupToPng(new XMLSerializer().serializeToString(copy), width, height, { background: false });
  } catch (error) {
    return Promise.resolve(null);
  }
}

async function collectFroalaIconSnapshots() {
  const icons = froalaToolbarIconSvgs();
  const snapshots = [];
  for (let i = 0; i < icons.length; i += 1) {
    const liveEl = icons[i];
    const toolbar = liveEl.closest('.fr-toolbar');
    if (toolbar && isActuallyHidden(toolbar)) continue;
    const rect = liveEl.getBoundingClientRect();
    const width = Math.max(16, Math.round(rect.width) || 24);
    const height = Math.max(16, Math.round(rect.height) || 24);
    const stamp = String(i + 1);
    liveEl.setAttribute('data-er-icon', stamp);
    const btn = liveEl.closest('.fr-command, button, a');
    if (btn && !btn.getAttribute('data-er-frbtn')) btn.setAttribute('data-er-frbtn', stamp);
    snapshots.push({
      stamp,
      width,
      height,
      png: await rasterizeFroalaIcon(liveEl, width, height)
    });
  }
  return snapshots;
}

function unstampFroalaIconSnapshots(snapshots) {
  (snapshots || []).forEach((snap) => {
    const icon = document.querySelector(`[data-er-icon="${snap.stamp}"]`);
    if (icon) icon.removeAttribute('data-er-icon');
    const btn = document.querySelector(`[data-er-frbtn="${snap.stamp}"]`);
    if (btn) btn.removeAttribute('data-er-frbtn');
  });
}

function appendFroalaCaptureStyle(clonedDoc) {
  if (!isCaptureCloneDoc(clonedDoc)) return;
  const style = clonedDoc.createElement('style');
  style.textContent = `
    .fr-toolbar .fr-command.fr-btn > span,
    .fr-toolbar span.fr-sr-only,
    .fr-popup span.fr-sr-only,
    .fr-modal span.fr-sr-only {
      display: none !important;
      font-size: 0 !important;
      width: 0 !important;
      height: 0 !important;
      overflow: hidden !important;
      position: absolute !important;
      color: transparent !important;
    }
    .fr-toolbar .fr-command.fr-btn svg.fr-svg,
    .fr-toolbar .fr-command.fr-btn img.fr-svg {
      display: inline-block !important;
      width: 24px !important;
      height: 24px !important;
      max-width: 24px !important;
      max-height: 24px !important;
    }
  `;
  (clonedDoc.head || clonedDoc.documentElement).appendChild(style);
}

function applyFroalaIconSnapshotsToClone(clonedDoc, snapshots) {
  if (!isCaptureCloneDoc(clonedDoc)) return;
  appendFroalaCaptureStyle(clonedDoc);
  (snapshots || []).forEach((snap) => {
    if (!snap || !snap.png) return;
    const img = clonedDoc.createElement('img');
    img.className = 'fr-svg error-report-chart-snapshot';
    img.src = snap.png;
    img.width = snap.width;
    img.height = snap.height;
    img.setAttribute('width', String(snap.width));
    img.setAttribute('height', String(snap.height));
    img.setAttribute('data-er-icon', snap.stamp);
    img.style.cssText = `display:inline-block;width:${snap.width}px;height:${snap.height}px;max-width:${snap.width}px;max-height:${snap.height}px;vertical-align:middle;`;
    const cloneSvg = clonedDoc.querySelector(`[data-er-icon="${snap.stamp}"]`);
    if (isCaptureCloneEl(clonedDoc, cloneSvg) && cloneSvg.parentNode) {
      cloneSvg.parentNode.replaceChild(img, cloneSvg);
      return;
    }
    const cloneBtn = clonedDoc.querySelector(`[data-er-frbtn="${snap.stamp}"]`);
    if (isCaptureCloneEl(clonedDoc, cloneBtn)) {
      cloneBtn.querySelectorAll('svg, span').forEach((node) => node.remove());
      cloneBtn.insertBefore(img, cloneBtn.firstChild);
    }
  });
}

function replaceCloneWithChartSnapshot(clonedDoc, clonedEl, dataUrl, width, height) {
  if (!isCaptureCloneEl(clonedDoc, clonedEl) || !dataUrl) return;
  clonedEl.innerHTML = '';
  const img = clonedDoc.createElement('img');
  img.className = 'error-report-chart-snapshot';
  img.src = dataUrl;
  img.width = width;
  img.height = height;
  img.setAttribute('width', String(width));
  img.setAttribute('height', String(height));
  img.style.cssText = `display:block;width:${width}px;height:${height}px;max-width:${width}px;max-height:${height}px;`;
  clonedEl.appendChild(img);
}

// 260819nrai: html2canvas paints position:fixed at document top; pin header into the scrolled crop
function pinStickyHeaderInCaptureClone(clonedDoc) {
  if (!isCaptureCloneDoc(clonedDoc)) return;
  const liveHeader = document.getElementById('header');
  const clonedHeader = clonedDoc.getElementById('header');
  if (!liveHeader || !isCaptureCloneEl(clonedDoc, clonedHeader)) return;

  const style = window.getComputedStyle(liveHeader);
  const pinned = style.position === 'fixed' || style.position === 'sticky' || liveHeader.classList.contains('fixed');
  if (!pinned) return;

  const rect = liveHeader.getBoundingClientRect();
  if (rect.width < 1 || rect.height < 1) return;

  clonedHeader.style.setProperty('position', 'absolute', 'important');
  clonedHeader.style.setProperty('top', `${window.scrollY + rect.top}px`, 'important');
  clonedHeader.style.setProperty('left', `${window.scrollX + rect.left}px`, 'important');
  clonedHeader.style.setProperty('right', 'auto', 'important');
  clonedHeader.style.setProperty('bottom', 'auto', 'important');
  clonedHeader.style.setProperty('width', `${Math.max(rect.width, window.innerWidth)}px`, 'important');
  clonedHeader.style.setProperty('margin', '0', 'important');
  clonedHeader.style.setProperty('transform', 'none', 'important');
  clonedHeader.style.setProperty('z-index', '2147483646', 'important');

  clonedHeader.querySelectorAll('.fixed').forEach((el) => {
    el.style.setProperty('position', 'relative', 'important');
    el.style.setProperty('top', '0', 'important');
    el.style.setProperty('left', '0', 'important');
  });
}

function collapseHeaderMenus(root, hideWithInlineStyles) {
  if (!root || !root.querySelectorAll) return;
  root.querySelectorAll('#header .hover, #header .moved, .top-bar .hover, .top-bar .moved').forEach((el) => {
    el.classList.remove('hover', 'moved');
  });
  if (!hideWithInlineStyles) return;
  root.querySelectorAll('#header ul.dropdown, .top-bar-section ul.dropdown').forEach((el) => {
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('opacity', '0', 'important');
  });
}

function collapseHeaderMenusInClone(clonedDoc) {
  if (!isCaptureCloneDoc(clonedDoc)) return;
  const style = clonedDoc.createElement('style');
  style.textContent = `
    #header ul.dropdown,
    .top-bar-section ul.dropdown,
    .top-bar-section .has-dropdown.hover > .dropdown,
    .top-bar-section .has-dropdown.not-click:hover > .dropdown,
    .top-bar-section .has-dropdown > a:focus + .dropdown {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      clip: rect(0, 0, 0, 0) !important;
      height: 0 !important;
      width: 0 !important;
      overflow: hidden !important;
    }
  `;
  (clonedDoc.head || clonedDoc.documentElement).appendChild(style);
  collapseHeaderMenus(clonedDoc, true);
}

// Close the reveal first so the overlay is gone, then capture the visible viewport.
async function captureViewportScreenshot() {
  const debug = collect_screenshot_debug();
  await waitFrames(2);
  // 260819nrai: only strip hover classes on the live DOM; inline display:none broke avatar menu hover
  collapseHeaderMenus(document, false);
  restoreHeaderMenuInlineStyles();
  const max_width = 1920;
  const stamped_controls = stampCaptureControls();
  const stamped_boxes = stampPercentHeightBoxes();
  const stamped_sr_only = stampHtml2canvasIgnore('.fr-sr-only, .fr-more-toolbar:not(.fr-expanded)');
  let chart_sizes = [];
  let froala_icon_snapshots = [];
  try {
    const chart_snapshots = await collectLiveChartSnapshots();
    froala_icon_snapshots = await collectFroalaIconSnapshots();
    chart_sizes = snapshotLiveChartSizes();
    debug.chart_snapshots = chart_snapshots.map((snap) => ({
      id: snap.id,
      parentId: snap.parentId,
      width: snap.width,
      height: snap.height,
      has_png: !!snap.png
    }));
    debug.froala_icons = froala_icon_snapshots.length;

  const export_blob = async (ignore_fn, sanitize_mode) => {
    // 260820nrai: wrap before clone — html2canvas parses getComputedStyle then, not in onclone
    const restoreComputedStyle = installHtml2canvasComputedStyleGuard(window);
    let canvas;
    try {
      canvas = await withTimeout(
        run_html2canvas(document.body, html2canvas_capture_options(ignore_fn, sanitize_mode, chart_snapshots, froala_icon_snapshots)),
        20000,
        'Screenshot-Timeout'
      );
    } finally {
      restoreComputedStyle();
    }
    let export_canvas = canvas;
    if (canvas.width > max_width) {
      const scaled = document.createElement('canvas');
      const ratio = max_width / canvas.width;
      scaled.width = max_width;
      scaled.height = Math.round(canvas.height * ratio);
      try {
        scaled.getContext('2d').drawImage(canvas, 0, 0, scaled.width, scaled.height);
        export_canvas = scaled;
      } catch (error) {
        if (!is_security_error(error)) throw error;
      }
    }
    return canvas_to_jpeg_blob(export_canvas);
  };

  const attempts = [
    {
      name: 'cross_origin_skip',
      sanitize: 'cross_origin',
      ignore: (el) => {
        if (isChartSnapshotElement(el)) return false;
        return ignoreCaptureElement(el) || is_cross_origin_media(el) || is_embed_element(el);
      }
    },
    {
      name: 'media_skip',
      sanitize: 'all_external',
      ignore: (el) => {
        if (isChartSnapshotElement(el)) return false;
        return ignoreCaptureElement(el) || is_media_element(el) || is_embed_element(el);
      }
    },
    {
      name: 'no_images',
      sanitize: 'no_images',
      ignore: (el) => {
        if (isChartSnapshotElement(el)) return false;
        return ignoreCaptureElement(el) || is_media_element(el) || is_embed_element(el);
      }
    }
  ];

  const attach_debug = (error) => {
    const err = (error && typeof error === 'object') ? error : new Error(String(error || 'Screenshot fehlgeschlagen'));
    if (!err.message && error) err.message = String(error);
    err.screenshot_debug = debug;
    return err;
  };

    for (let i = 0; i < attempts.length; i += 1) {
      const attempt = attempts[i];
      try {
        const blob = await export_blob(attempt.ignore, attempt.sanitize);
        debug.attempts.push({ name: attempt.name, message: 'ok' });
        console.info('[error-report] screenshot captured via', attempt.name, debug);
        return blob;
      } catch (error) {
        const message = (error && error.message) ? error.message : String(error || '');
        debug.attempts.push({
          name: attempt.name,
          error_name: (error && error.name) ? error.name : '',
          message
        });
        if (!is_retryable_screenshot_error(error) || i === attempts.length - 1) {
          throw attach_debug(error);
        }
      }
    }

    throw attach_debug(security_error('Screenshot konnte nicht exportiert werden'));
  } finally {
    unstampCaptureControls(stamped_controls);
    unstampPercentHeightBoxes(stamped_boxes);
    unstampHtml2canvasIgnore(stamped_sr_only);
    unstampFroalaIconSnapshots(froala_icon_snapshots);
    restoreLiveChartSizes(chart_sizes);
  }
}

async function setScreenshotPreview(blob) {
  const modal = errorReportModal();
  clearScreenshotPreview();
  if (!blob) {
    modal.removeData('screenshotBlob');
    return;
  }
  modal.data('screenshotBlob', blob);
  try {
    await loadBlobOntoAnnotationCanvas(blob);
    $('#error_report_screenshot_missing').hide();
  } catch (error) {
    const objectUrl = URL.createObjectURL(blob);
    modal.data('screenshotObjectUrl', objectUrl);
    const preview = document.getElementById('error_report_screenshot_preview');
    if (preview) {
      preview.src = objectUrl;
      preview.hidden = false;
    }
    $('#error_report_screenshot_missing').hide();
  }
}

function isGenoeasyGenogramOnScreen() {
  const frame = document.getElementById('genoeasy-frame');
  if (!frame || isActuallyHidden(frame)) return false;
  const container = document.getElementById('genogram_container');
  if (container && (container.classList.contains('hidden') || isActuallyHidden(container))) return false;
  const rect = frame.getBoundingClientRect();
  if (rect.width < 1 || rect.height < 1) return false;
  return rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
}

function setGenogramScreenshotWarning(show) {
  const note = document.getElementById('error_report_genogram_screenshot_note');
  if (!note) return;
  note.hidden = !show;
}

async function takeScreenshotAndContinue() {
  const modal = errorReportModal();
  const forcedMeta = modal.data('forcedMeta');
  // 260826nrai: html2canvas cannot paint the cross-origin GenoEasy iframe
  const genogramOnScreen = isGenoeasyGenogramOnScreen();
  await closeRevealForCapture();
  let blob = null;
  try {
    blob = await captureViewportScreenshot();
  } catch (error) {
    console.error('error report screenshot failed', error, error && error.screenshot_debug);
    showErrorReportToast(format_screenshot_error_toast(error), 'error', 20000);
  }
  openErrorReportModal({ skipScreenshot: true, meta: forcedMeta });
  await setScreenshotPreview(blob);
  setGenogramScreenshotWarning(genogramOnScreen);
}

function error_text(error, fallback) {
  if (error == null) return fallback;
  if (typeof error === 'string' && error.trim()) return error;
  if (error.message) return error.message;
  return fallback;
}

function buildErrorReportMeta() {
  const modal = errorReportModal();
  const forced = modal.data('forcedMeta') || {};
  return Object.assign({
    url: window.location.href,
    host: window.location.host,
    controller: modal.data('currentController'),
    action: modal.data('currentAction'),
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    source: forced.source || 'menu'
  }, forced);
}

async function build_error_report_form_data(description) {
  const modal = errorReportModal();
  const form_data = new FormData();
  form_data.append('error_report[description]', description);
  const meta = buildErrorReportMeta();
  Object.keys(meta).forEach((key) => {
    const value = meta[key];
    if (value == null || value === '') return;
    // 260824nrai: application_stack is an array of frames
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item == null || item === '') return;
        form_data.append(`error_report[meta][${key}][]`, String(item));
      });
      return;
    }
    form_data.append(`error_report[meta][${key}]`, String(value));
  });
  let screenshot_blob = modal.data('screenshotBlob');
  try {
    const annotated = await exportAnnotatedScreenshotBlob();
    if (annotated) screenshot_blob = annotated;
  } catch (e) { /* keep original jpeg */ }
  if (screenshot_blob) {
    form_data.append(
      'error_report[screenshot]',
      screenshot_blob,
      'error-report-screenshot.jpg'
    );
  }
  return form_data;
}

async function parse_error_report_response(response) {
  const content_type = (response.headers.get('content-type') || '').toLowerCase();
  if (content_type.indexOf('json') !== -1) {
    return response.json().catch(() => ({}));
  }
  const text = await response.text().catch(() => '');
  return {
    success: false,
    error: text ? `HTTP ${response.status}: ${text.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 240)}` : `HTTP ${response.status}`
  };
}

async function submitErrorReport() {
  const modal = errorReportModal();
  const description = ($('#error_report_description').val() || '').trim();
  const errorEl = $('#error_report_form_error');
  if (!description) {
    errorEl.text('Bitte eine Fehlerbeschreibung eingeben.').attr('hidden', false);
    return;
  }
  errorEl.text('').attr('hidden', true);
  const submitButton = $('#error_report_submit');
  submitButton.addClass('disabled');
  try {
    const response = await fetch(modal.data('createUrl'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': csrfToken()
      },
      body: await build_error_report_form_data(description)
    });
    const data = await parse_error_report_response(response);
    if (!response.ok || data.success === false) {
      throw new Error(data.error || `HTTP ${response.status}`);
    }
    closeErrorReportModal();
    showErrorReportToast(data.notice || 'Fehlerbericht wurde gesendet.', 'success');
  } catch (error) {
    console.error('error report submit failed', error);
    errorEl.text(error_text(error, 'Fehlerbericht konnte nicht gesendet werden.')).attr('hidden', false);
  } finally {
    submitButton.removeClass('disabled');
  }
}

function initErrorReportCapture() {
  $(document).off('click.errorReportIcon', '#error_report_link')
    .on('click.errorReportIcon', '#error_report_link', function (event) {
      event.preventDefault();
      openErrorReportModal();
    });

  $(document).off('click.errorReportTake', '#error_report_take_screenshot')
    .on('click.errorReportTake', '#error_report_take_screenshot', async function (event) {
      event.preventDefault();
      const button = $(this);
      button.addClass('disabled');
      try {
        await takeScreenshotAndContinue();
      } finally {
        button.removeClass('disabled');
      }
    });

  $(document).off('click.errorReportSkip', '#error_report_skip_screenshot')
    .on('click.errorReportSkip', '#error_report_skip_screenshot', function (event) {
      event.preventDefault();
      setScreenshotPreview(null);
      setErrorReportStep('compose');
    });

  $(document).off('click.errorReportCancel', '#error_report_cancel_explain, #error_report_cancel_compose')
    .on('click.errorReportCancel', '#error_report_cancel_explain, #error_report_cancel_compose', function (event) {
      event.preventDefault();
      closeErrorReportModal();
    });

  $(document).off('click.errorReportSubmit', '#error_report_submit')
    .on('click.errorReportSubmit', '#error_report_submit', function (event) {
      event.preventDefault();
      submitErrorReport();
    });

  $(document).off('click.errorReportAnnotateUndo', '#error_report_screenshot_undo')
    .on('click.errorReportAnnotateUndo', '#error_report_screenshot_undo', undoScreenshotAnnotation);

  $(document).off('click.errorReportAnnotateClear', '#error_report_screenshot_clear')
    .on('click.errorReportAnnotateClear', '#error_report_screenshot_clear', clearScreenshotAnnotation);

  $(document).off('click.errorReportDrawExpand', '#error_report_screenshot_expand, .error-report-screenshot-expand-open')
    .on('click.errorReportDrawExpand', '#error_report_screenshot_expand, .error-report-screenshot-expand-open', function (event) {
      event.preventDefault();
      openScreenshotDrawOverlay();
    });

  $(document).off('click.errorReportDrawDone', '#error_report_screenshot_done')
    .on('click.errorReportDrawDone', '#error_report_screenshot_done', function (event) {
      event.preventDefault();
      event.stopPropagation();
      closeScreenshotDrawOverlay();
    });

  $(document).off('click.errorReportDrawClose', '#error_report_screenshot_draw')
    .on('click.errorReportDrawClose', '#error_report_screenshot_draw', function (event) {
      if (event.target !== this) return;
      event.preventDefault();
      closeScreenshotDrawOverlay();
    });

  $(document).off('keydown.errorReportDraw keyup.errorReportDraw')
    .on('keydown.errorReportDraw keyup.errorReportDraw', function (event) {
      if (event.key !== 'Escape' && event.which !== 27) return;
      if (!isScreenshotDrawOpen()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (event.type === 'keydown') closeScreenshotDrawOverlay();
    });

  $(document).off('pointerdown.errorReportAnnotate', '#error_report_screenshot_canvas')
    .on('pointerdown.errorReportAnnotate', '#error_report_screenshot_canvas', startScreenshotAnnotation);
  $(document).off('pointermove.errorReportAnnotate', '#error_report_screenshot_canvas')
    .on('pointermove.errorReportAnnotate', '#error_report_screenshot_canvas', moveScreenshotAnnotation);
  $(document).off('pointerup.errorReportAnnotate pointercancel.errorReportAnnotate', '#error_report_screenshot_canvas')
    .on('pointerup.errorReportAnnotate pointercancel.errorReportAnnotate', '#error_report_screenshot_canvas', endScreenshotAnnotation);

  $(document).off('click.errorReportPage', '.error-report-from-error-page')
    .on('click.errorReportPage', '.error-report-from-error-page', function (event) {
      event.preventDefault();
      const button = $(event.currentTarget);
      let meta = button.data('errorReportMeta');
      if (typeof meta === 'string') {
        try {
          meta = JSON.parse(meta);
        } catch (error) {
          meta = {};
        }
      }
      meta = meta || {};
      meta.source = 'error_page';
      if (typeof meta.application_stack === 'string') {
        meta.application_stack = meta.application_stack.split(/\r?\n/).filter(Boolean);
      }
      const prefill = meta.prefill_description;
      delete meta.prefill_description;
      openErrorReportModal({ skipScreenshot: true, meta: meta });
      if (prefill) {
        $('#error_report_description').val(prefill);
      }
    });
}

function selectedErrorReportIds(root) {
  return Array.from(root.querySelectorAll('.error-reports-row-checkbox:checked'))
    .map((box) => box.value)
    .filter(Boolean);
}

function updateErrorReportsBulkVisibility(root) {
  const actions = root.querySelector('.error-reports-bulk-actions');
  if (!actions) return;
  const selected = selectedErrorReportIds(root);
  actions.hidden = selected.length === 0;
}

function postErrorReportsBulk(root, bulkAction) {
  const ids = selectedErrorReportIds(root);
  if (!ids.length) return;
  const form = document.createElement('form');
  form.method = 'post';
  form.action = root.dataset.bulkUrl;
  const csrf = document.createElement('input');
  csrf.type = 'hidden';
  csrf.name = 'authenticity_token';
  csrf.value = csrfToken();
  form.appendChild(csrf);
  const actionInput = document.createElement('input');
  actionInput.type = 'hidden';
  actionInput.name = 'bulk_action';
  actionInput.value = bulkAction;
  form.appendChild(actionInput);
  const tabInput = document.createElement('input');
  tabInput.type = 'hidden';
  tabInput.name = 'tab';
  tabInput.value = root.dataset.tab || 'open';
  form.appendChild(tabInput);
  ids.forEach((id) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'ids[]';
    input.value = id;
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
}

function exportErrorReportsPdf(root) {
  const ids = selectedErrorReportIds(root);
  if (!ids.length) return;
  const url = new URL(root.dataset.exportUrl, window.location.origin);
  ids.forEach((id) => url.searchParams.append('ids[]', id));
  url.searchParams.set('tab', root.dataset.tab || 'open');
  window.open(url.toString(), '_blank', 'noopener');
}

function debounce(fn, ms) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), ms);
  };
}

function errorReportsFilterQuery(form) {
  const params = new URLSearchParams(new FormData(form));
  ['search', 'date_from', 'date_to'].forEach((key) => {
    if (!(params.get(key) || '').trim()) params.delete(key);
  });
  return params;
}

function errorReportsFiltersActive(form) {
  const params = errorReportsFilterQuery(form);
  return !!(params.get('search') || params.get('date_from') || params.get('date_to'));
}

function errorReportsActivePanel() {
  return document.querySelector('#error_reports_tabs .r-tabs-panel.r-tabs-state-active [data-error-reports-admin]')
    || document.querySelector('[data-error-reports-admin]');
}

function errorReportsAdminPanel(root) {
  if (!root) return errorReportsActivePanel();
  if (root.matches?.('[data-error-reports-admin]')) return root;
  return root.querySelector('[data-error-reports-admin]');
}

function errorReportsFilterValue(key) {
  const form = errorReportsActivePanel()?.querySelector('.error-reports-filters');
  if (form) return (errorReportsFilterQuery(form).get(key) || '').trim();
  return (new URLSearchParams(window.location.search).get(key) || '').trim();
}

function errorReportsSyncUrl(tab) {
  const url = new URL(window.location.href);
  url.searchParams.set('tab', tab);
  url.searchParams.delete('open_id');
  ['search', 'date_from', 'date_to'].forEach((key) => {
    const value = errorReportsFilterValue(key);
    if (value) url.searchParams.set(key, value);
    else url.searchParams.delete(key);
  });
  const query = url.searchParams.toString();
  history.replaceState(null, '', url.pathname + (query ? `?${query}` : ''));
}

function errorReportsPanelUrl() {
  return document.getElementById('error_reports_tabs')?.dataset.panelUrl || '/error_reports/panel';
}

function updateErrorReportsResetVisibility(form) {
  const reset = form.querySelector('.error-reports-reset-filters');
  if (!reset) return;
  reset.style.display = errorReportsFiltersActive(form) ? '' : 'none';
}

// 260817nrai: show the shared loading partial inside the destination tab (messages inbox pattern)
function errorReportsTabShowLoading(tabKey) {
  $(`#error_reports_panel_${tabKey}_loading`).show();
  $(`#error_reports_panel_${tabKey}_content`).hide();
}

function errorReportsTabHideLoading(tabKey) {
  $(`#error_reports_panel_${tabKey}_loading`).hide();
  $(`#error_reports_panel_${tabKey}_content`).show();
}

function showErrorReportsListLoading(panel) {
  const root = panel || errorReportsActivePanel();
  if (!root) return;
  const loading = root.querySelector('.error-reports-list-loading');
  const content = root.querySelector('.error-reports-list-content');
  if (loading) loading.style.display = '';
  if (content) content.style.display = 'none';
}

function submitErrorReportsFilters(form) {
  const params = errorReportsFilterQuery(form);
  const currentParams = new URLSearchParams(window.location.search);
  const keys = ['tab', 'search', 'date_from', 'date_to'];
  const same = keys.every((key) => (params.get(key) || '').trim() === (currentParams.get(key) || '').trim());
  if (same) return;

  const tab = params.get('tab') || 'open';
  const panel = form.closest('[data-error-reports-admin]');
  showErrorReportsListLoading(panel);

  $.post(errorReportsPanelUrl(), Object.fromEntries(params))
    .done((html) => {
      $(`#error_reports_panel_${tab}_content`).html(html);
      initErrorReportsAdmin(document.getElementById(`error_reports_panel_${tab}_content`));
      errorReportsSyncUrl(tab);
    })
    .fail(() => {
      showErrorReportToast('Liste konnte nicht geladen werden.', 'error');
      const loading = panel?.querySelector('.error-reports-list-loading');
      const content = panel?.querySelector('.error-reports-list-content');
      if (loading) loading.style.display = 'none';
      if (content) content.style.display = '';
    });
}

function initErrorReportsFilters(panel) {
  const form = panel.querySelector('.error-reports-filters');
  if (!form) return;

  if (typeof window.init_datetimepicker === 'function') {
    window.init_datetimepicker();
  }

  updateErrorReportsResetVisibility(form);

  const submitDebounced = debounce(() => submitErrorReportsFilters(form), 400);
  const searchInput = form.querySelector('.error-reports-search-input');
  if (searchInput) {
    searchInput.addEventListener('input', () => {
      updateErrorReportsResetVisibility(form);
      submitDebounced();
    });
    searchInput.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        submitErrorReportsFilters(form);
      }
    });
  }

  form.querySelectorAll('.error-reports-date-input').forEach((input) => {
    $(input).off('change.errorReportsFilter changedatetime.xdsoft')
      .on('change.errorReportsFilter changedatetime.xdsoft', () => {
        updateErrorReportsResetVisibility(form);
        submitErrorReportsFilters(form);
      });
  });

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    submitErrorReportsFilters(form);
  });

  const reset = form.querySelector('.error-reports-reset-filters');
  if (reset) {
    reset.addEventListener('click', (event) => {
      event.preventDefault();
      if (searchInput) searchInput.value = '';
      form.querySelectorAll('.error-reports-date-input').forEach((input) => { input.value = ''; });
      updateErrorReportsResetVisibility(form);
      submitErrorReportsFilters(form);
    });
  }
}

async function openErrorReportDetail(id) {
  if (!id) return;
  const response = await fetch(`/error_reports/${id}.html?modal=1`, {
    headers: {
      Accept: 'text/html',
      'X-Requested-With': 'XMLHttpRequest'
    }
  });
  if (!response.ok) {
    showErrorReportToast('Bericht konnte nicht geladen werden.', 'error');
    return;
  }
  const html = await response.text();
  const modal = $('#error_report_detail_modal');
  if (!modal.length) return;
  modal.find('#error_report_detail_body').html(html);
  syncErrorReportCommentSaveButton(modal.find('.error-report-comment-form').get(0));
  // 260817nrai: Foundation caches css-top/offset on first open; % top becomes 4px and the modal collapses.
  modal.removeData('css-top').removeData('offset');
  if (!modal.data('reveal')) {
    try { modal.foundation('reveal'); } catch (e) { /* already inited */ }
  }
  modal.foundation('reveal', 'open');
}

async function submitErrorReportComment(form) {
  const formData = new FormData(form);
  if (!formData.get('_method')) formData.append('_method', 'patch');
  formData.append('modal', '1');
  const actionUrl = new URL(form.action, window.location.origin);
  if (!actionUrl.pathname.endsWith('.html')) {
    actionUrl.pathname += '.html';
  }
  const response = await fetch(actionUrl.toString(), {
    method: 'POST',
    headers: {
      Accept: 'text/html',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': csrfToken()
    },
    body: formData
  });
  const html = await response.text();
  if (!response.ok) {
    showErrorReportToast('Kommentar konnte nicht gespeichert werden.', 'error');
    return;
  }
  $('#error_report_detail_body').html(html);
  syncErrorReportCommentSaveButton(document.querySelector('#error_report_detail_body .error-report-comment-form'));
  showErrorReportToast('Kommentar gespeichert.', 'success');
}

function openErrorReportScreenshotZoom(src) {
  if (!src) return;
  const overlay = document.getElementById('error_report_screenshot_zoom');
  if (!overlay) return;
  const img = overlay.querySelector('img');
  if (img) img.src = src;
  overlay.hidden = false;
}

function closeErrorReportScreenshotZoom() {
  const overlay = document.getElementById('error_report_screenshot_zoom');
  if (!overlay || overlay.hidden) return;
  overlay.hidden = true;
  const img = overlay.querySelector('img');
  if (img) img.removeAttribute('src');
}

function syncErrorReportCommentSaveButton(form) {
  if (!form) return;
  const textarea = form.querySelector('textarea');
  const actions = form.querySelector('.error-report-comment-form-actions');
  const button = form.querySelector('.error-report-save-comment');
  if (!textarea || !button) return;
  // Rails text_area prepends a newline; bind the real initial value after render.
  if (!textarea.dataset.originalBound) {
    textarea.setAttribute('data-original', textarea.value);
    textarea.dataset.originalBound = '1';
  }
  const changed = textarea.value !== (textarea.getAttribute('data-original') || '');
  button.hidden = !changed;
  if (actions) actions.hidden = !changed;
}

function errorReportReplyFroala() {
  if (window.editorerror_report_replybody) return window.editorerror_report_replybody;
  if (window.FroalaEditor && FroalaEditor.INSTANCES) {
    const instances = FroalaEditor.INSTANCES;
    for (let i = 0; i < instances.length; i += 1) {
      const editor = instances[i];
      const el = editor && editor.$oel && editor.$oel[0];
      if (el && el.id === 'error_report_reply_body') return editor;
    }
  }
  return null;
}

function errorReportReplyBodyHtml() {
  const froala = errorReportReplyFroala();
  if (froala && froala.html && typeof froala.html.get === 'function') {
    return froala.html.get(true) || '';
  }
  return ($('#error_report_reply_body').val() || '').trim();
}

function clearErrorReportReplyBody() {
  const froala = errorReportReplyFroala();
  if (froala && froala.html && typeof froala.html.set === 'function') {
    froala.html.set('');
    return;
  }
  $('#error_report_reply_body').val('');
}

// 260902nrai: Antworten popup (An / Betreff / Nachricht + quoted report)
function openErrorReportReplyModal(button) {
  const modal = $('#error_report_reply_modal');
  if (!modal.length || !button) return;
  const data = button.dataset || {};
  modal.data('replyUrl', data.replyUrl);
  modal.data('errorReportId', data.errorReportId);
  $('#error_report_reply_receiver').text(data.receiverName || '—');
  $('#error_report_reply_subject').val(data.subject || '');
  clearErrorReportReplyBody();
  $('#error_report_reply_error').text('').attr('hidden', true);
  const desc = document.getElementById('error_report_reply_quote_description');
  if (desc) desc.textContent = data.description || '';
  const img = document.getElementById('error_report_reply_quote_screenshot');
  if (img) {
    if (data.screenshotUrl) {
      img.src = data.screenshotUrl;
      img.hidden = false;
    } else {
      img.removeAttribute('src');
      img.hidden = true;
    }
  }
  $('#error_report_detail_modal').foundation('reveal', 'close');
  modal.removeData('css-top').removeData('offset');
  if (!modal.data('reveal')) {
    try { modal.foundation('reveal'); } catch (e) { /* already inited */ }
  }
  window.setTimeout(() => {
    modal.foundation('reveal', 'open');
    const froala = errorReportReplyFroala();
    if (froala) {
      if (froala.size && typeof froala.size.refresh === 'function') froala.size.refresh();
      if (froala.events && typeof froala.events.focus === 'function') froala.events.focus();
    } else {
      $('#error_report_reply_body').trigger('focus');
    }
  }, 180);
}

function closeErrorReportReplyModal() {
  const modal = $('#error_report_reply_modal');
  if (modal.length) {
    modal.foundation('reveal', 'close');
  }
}

async function sendErrorReportReply() {
  const modal = $('#error_report_reply_modal');
  const url = modal.data('replyUrl');
  if (!url) return;
  const subject = ($('#error_report_reply_subject').val() || '').trim();
  const body = errorReportReplyBodyHtml();
  const bodyText = body.replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').trim();
  const errorEl = $('#error_report_reply_error');
  if (!subject || !bodyText) {
    errorEl.text('Betreff und Nachricht sind erforderlich.').removeAttr('hidden');
    return;
  }
  errorEl.text('').attr('hidden', true);
  const sendBtn = document.getElementById('error_report_reply_send');
  if (sendBtn) sendBtn.classList.add('disabled');
  const formData = new URLSearchParams();
  formData.append('subject', subject);
  formData.append('body', body);
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken()
      },
      body: formData.toString()
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok || !payload.success) {
      const msg = payload.error === 'missing_fields'
        ? 'Betreff und Nachricht sind erforderlich.'
        : 'Die Nachricht konnte nicht gesendet werden.';
      errorEl.text(msg).removeAttr('hidden');
      return;
    }
    closeErrorReportReplyModal();
    showErrorReportToast(payload.message || 'Die Nachricht wurde gesendet.', 'success');
    const reportId = modal.data('errorReportId') || payload.id;
    if (reportId) {
      const row = document.querySelector(`tr.error-reports-row[data-error-report-id="${reportId}"]`);
      const cell = row && row.querySelector('.error-reports-reply-col');
      if (cell && !cell.querySelector('.error-reports-reply-indicator')) {
        cell.innerHTML = '<span class="error-reports-reply-indicator" title="Antwort gesendet"><i class="fa fa-reply"></i></span>';
      }
      openErrorReportDetail(reportId);
    }
  } catch (error) {
    errorEl.text('Die Nachricht konnte nicht gesendet werden.').removeAttr('hidden');
  } finally {
    if (sendBtn) sendBtn.classList.remove('disabled');
  }
}

function initErrorReportDetailModal() {
  $(document).off('click.errorReportDetailRow', '.error-reports-row')
    .on('click.errorReportDetailRow', '.error-reports-row', function (event) {
      if ($(event.target).closest('.error-reports-check-col, input, label, .error-reports-login-as').length) return;
      event.preventDefault();
      const id = this.getAttribute('data-error-report-id');
      openErrorReportDetail(id);
    });

  $(document).off('click.errorReportDetailClose', '.error-report-detail-close')
    .on('click.errorReportDetailClose', '.error-report-detail-close', function (event) {
      event.preventDefault();
      $('#error_report_detail_modal').foundation('reveal', 'close');
    });

  $(document).off('click.errorReportSaveComment', '.error-report-save-comment')
    .on('click.errorReportSaveComment', '.error-report-save-comment', function (event) {
      event.preventDefault();
      const form = $(this).closest('.error-report-comment-form').get(0);
      if (form) submitErrorReportComment(form);
    });

  $(document).off('input.errorReportComment', '.error-report-comment-form textarea')
    .on('input.errorReportComment', '.error-report-comment-form textarea', function () {
      syncErrorReportCommentSaveButton(this.form);
    });

  $(document).off('submit.errorReportComment', '.error-report-comment-form')
    .on('submit.errorReportComment', '.error-report-comment-form', function (event) {
      event.preventDefault();
      submitErrorReportComment(this);
    });

  $(document).off('click.errorReportScreenshotZoom', '.error-report-screenshot-zoom-open')
    .on('click.errorReportScreenshotZoom', '.error-report-screenshot-zoom-open', function (event) {
      event.preventDefault();
      event.stopPropagation();
      const src = this.getAttribute('src') || $(this).closest('.error-report-detail-screenshot').find('img').attr('src');
      openErrorReportScreenshotZoom(src);
    });

  $(document).off('click.errorReportScreenshotZoomClose', '#error_report_screenshot_zoom, .error-report-screenshot-zoom-close')
    .on('click.errorReportScreenshotZoomClose', '#error_report_screenshot_zoom, .error-report-screenshot-zoom-close', function (event) {
      event.preventDefault();
      event.stopPropagation();
      closeErrorReportScreenshotZoom();
    });

  $(document).off('keydown.errorReportScreenshotZoom keyup.errorReportScreenshotZoom')
    .on('keydown.errorReportScreenshotZoom keyup.errorReportScreenshotZoom', function (event) {
      if (event.key !== 'Escape' && event.which !== 27) return;
      const overlay = document.getElementById('error_report_screenshot_zoom');
      if (!overlay || overlay.hidden) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (event.type === 'keydown') closeErrorReportScreenshotZoom();
    });

  $(document).off('click.errorReportReplyOpen', '.error-report-reply-open')
    .on('click.errorReportReplyOpen', '.error-report-reply-open', function (event) {
      event.preventDefault();
      event.stopPropagation();
      openErrorReportReplyModal(this);
    });

  $(document).off('click.errorReportReplySend', '#error_report_reply_send')
    .on('click.errorReportReplySend', '#error_report_reply_send', function (event) {
      event.preventDefault();
      if (this.classList.contains('disabled')) return;
      sendErrorReportReply();
    });

  $(document).off('click.errorReportReplyCancel', '.error-report-reply-cancel, #error_report_reply_modal .close-reveal-modal')
    .on('click.errorReportReplyCancel', '.error-report-reply-cancel', function (event) {
      event.preventDefault();
      closeErrorReportReplyModal();
    });
}

function initErrorReportsAdmin(root) {
  const panel = errorReportsAdminPanel(root);
  if (!panel) return;
  if (panel.dataset.errorReportsInited === '1') return;
  panel.dataset.errorReportsInited = '1';

  initErrorReportsFilters(panel);
  initErrorReportDetailModal();

  panel.querySelectorAll('.error-reports-row-checkbox').forEach((box) => {
    box.addEventListener('change', () => updateErrorReportsBulkVisibility(panel));
  });

  const selectAll = panel.querySelector('.error-reports-select-all');
  if (selectAll) {
    selectAll.addEventListener('change', () => {
      panel.querySelectorAll('.error-reports-row-checkbox').forEach((box) => {
        box.checked = selectAll.checked;
      });
      updateErrorReportsBulkVisibility(panel);
    });
  }

  const selectAllLink = panel.querySelector('.error-reports-select-all-link');
  if (selectAllLink) {
    selectAllLink.addEventListener('click', (event) => {
      event.preventDefault();
      panel.querySelectorAll('.error-reports-row-checkbox').forEach((box) => { box.checked = true; });
      if (selectAll) selectAll.checked = true;
      updateErrorReportsBulkVisibility(panel);
    });
  }

  const selectNoneLink = panel.querySelector('.error-reports-select-none-link');
  if (selectNoneLink) {
    selectNoneLink.addEventListener('click', (event) => {
      event.preventDefault();
      panel.querySelectorAll('.error-reports-row-checkbox').forEach((box) => { box.checked = false; });
      if (selectAll) selectAll.checked = false;
      updateErrorReportsBulkVisibility(panel);
    });
  }

  panel.querySelector('.error-reports-bulk-forward')?.addEventListener('click', () => postErrorReportsBulk(panel, 'forward'));
  panel.querySelector('.error-reports-bulk-archive')?.addEventListener('click', () => postErrorReportsBulk(panel, 'archive'));
  panel.querySelector('.error-reports-bulk-mail')?.addEventListener('click', () => postErrorReportsBulk(panel, 'mail'));
  panel.querySelector('.error-reports-bulk-export')?.addEventListener('click', () => exportErrorReportsPdf(panel));

  if (panel.dataset.openId) {
    openErrorReportDetail(panel.dataset.openId);
  }
}

function initErrorReportsUi() {
  restoreHeaderMenuInlineStyles();
  initErrorReportCapture();
  initErrorReportsAdmin();
}

export {
  initErrorReportsUi,
  openErrorReportModal,
  initErrorReportsAdmin
};

window.openErrorReportModal = openErrorReportModal;
window.initErrorReportsAdmin = initErrorReportsAdmin;
window.showErrorReportsListLoading = showErrorReportsListLoading;
window.errorReportsTabShowLoading = errorReportsTabShowLoading;
window.errorReportsTabHideLoading = errorReportsTabHideLoading;
window.errorReportsFilterValue = errorReportsFilterValue;
window.errorReportsSyncUrl = errorReportsSyncUrl;
